'use client';

import Link from 'next/link';
import { Anchor, Button, Container, Group, Paper, Stack, Text, Title } from '@mantine/core';
import { getCarComparisonLinkProps } from '../../../lib/content/comparisonLinks';
import {
  widgetLinkStyle,
  widgetPrimaryButtonStyles,
  widgetSectionPadding,
  widgetSubtitleStyle,
  widgetTitleStyle,
} from './widgetStyles';

export function CtaBannerWidget({
  title,
  subtitle,
  primaryCtaLabel,
  primaryCtaHref,
  secondaryCtaLabel,
  secondaryCtaHref,
  mapHref,
}: {
  title?: string;
  subtitle?: string;
  primaryCtaLabel?: string;
  primaryCtaHref?: string;
  secondaryCtaLabel?: string;
  secondaryCtaHref?: string;
  mapHref: (href?: string) => string | undefined;
}) {
  if (!title && !subtitle && !primaryCtaLabel && !secondaryCtaLabel) return null;

  const primaryHref = primaryCtaLabel ? mapHref(primaryCtaHref) : undefined;
  const secondaryHref = secondaryCtaLabel ? mapHref(secondaryCtaHref) : undefined;

  return (
    <Container size="xl" py={widgetSectionPadding}>
      <Paper
        p={{ base: 24, md: 34 }}
        radius={40}
        withBorder
        style={{ borderColor: 'var(--surface-border)', background: 'var(--surface-soft)' }}
      >
        <Stack gap={12}>
          {title ? <Title order={2} style={widgetTitleStyle}>{title}</Title> : null}
          {subtitle ? <Text style={widgetSubtitleStyle}>{subtitle}</Text> : null}

          {(primaryHref || secondaryHref) ? (
            <Group mt={6}>
              {primaryHref ? (
                <Button
                  component={Link}
                  href={primaryHref}
                  {...getCarComparisonLinkProps(primaryHref)}
                  styles={widgetPrimaryButtonStyles}
                >
                  {primaryCtaLabel}
                </Button>
              ) : null}

              {secondaryHref ? (
                <Anchor
                  component={Link}
                  href={secondaryHref}
                  {...getCarComparisonLinkProps(secondaryHref)}
                  underline="never"
                  style={widgetLinkStyle}
                >
                  {secondaryCtaLabel}
                </Anchor>
              ) : null}
            </Group>
          ) : null}
        </Stack>
      </Paper>
    </Container>
  );
}
